
<t4-list-view #listVw [options]="listOptions" (onItemSelectionChange)="OnItemSelectionChange($event)"  (onDirectSelection)="actionClick('rowclick', $any($event))" (onDataRequest)="onDataRequest($event)">
  <t4-date-time-control [beforeToday]="false" [labelDate]="'CUSTOM.BUTTON.STATE.FORM.FROM-DATE'" [labelTime]="'CUSTOM.BUTTON.STATE.FORM.FROM-TIME'"></t4-date-time-control>

  <ng-container *t4ListActions>
    @if (allowAdd === true && !isInArchiveMode) {
      <button (click)="actionClick('add')" class="btn btn-primary border" type="button"><i class="far fa-plus-square"></i>{{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
    }
  </ng-container>

  <ng-container *t4ListItem="let item">

    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.ExternalId }}">{{ item.CustomerNumber }} / {{item.ExternalId | replaceOnEmpty}}</td>
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Name }}"><t4-customer-identification-control [isIbaActive]="isIbaActive" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Age }}">{{ showAge(item.Age, item.CustomerType) }}</td>
    @if (isCustomerReworkActive) {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.ParentCompanyName }}">{{ item.ParentCompanyName | replaceOnEmpty }}</td>
      <td class= "company-info">
        @if (item.CustomerType == 1) {
          <span class="badge bg-success">{{ 'BTN.YES' | translate }}</span>
        } @else {
          <span class="badge bg-secondary">{{ 'BTN.NO' | translate }}</span>
        }
      </td>
    } @else {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Name }}">{{item.CustomerType == 1 ? item.Name : null | replaceOnEmpty }}</td>
    }
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Email }}">{{item.Email}}</td>
    @if (showAddress === true) {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ getCombinedAddress(item) }}">{{getCombinedAddress(item)}}</td>
    }

    @if (allowEdit) {
      <td class="grid-action">
        @if (!isInArchiveMode) {
          <button (click)="this.actionClick('edit', item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        }
        @if (!isInArchiveMode) {
          <button (click)="this.actionClick('delete', item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      </td>
    }


  </ng-container>

  <ng-container *t4ItemFilter="let kvp=kvp">


    <div class="row">
      <div class="col-lg-2">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-account"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.FIRSTNAME' | translate }}" (keyup.enter)='listVw.updateFilter($event)' name="FirstName" [(ngModel)]="kvp.FirstName" autocomplete="off">
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.MIDDLENAME' | translate }}" (keyup.enter)='listVw.updateFilter($event)' name="MiddleName" [(ngModel)]="kvp.MiddleName" autocomplete="off" style="max-width: 50px;">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-account"></span>
          

          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.LASTNAME' | translate }}" (keyup.enter)='listVw.updateFilter($event)'  name="LastName" [(ngModel)]="kvp.LastName" autocomplete="off">


        </div>
      </div>

      <div class="col-lg-2">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-calendar-heart"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.DATEOFBIRTH' | translate }}" style="width: 10px; display: inline-block" datepicker [beforeToday]="true" [(ngModel)]="kvp.DateOfBirth" name="DateOfBirth" autocomplete="off">
        </div>
      </div>

      <div class="col-lg-6">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-home-variant-outline"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.STREET' | translate }}"  name="Street" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.Street"  autocomplete="off">
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.STREETNR' | translate }}" name="StreetNr" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.StreetNr" autocomplete="off">
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CITY' | translate }}" name="City" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.City" autocomplete="off">
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.POSTALCODE' | translate }}" name="Postalcode" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.PostalCode" autocomplete="off">
        </div>
      </div>

    </div>

    <div class="row mt-1">
      <div class="col-lg-2">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-email"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" name="Email" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.EMAIL' | translate }}" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.Email" autocomplete="off">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-office-building"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" name="CompanyName" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.COMPANYNAME' | translate }}" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.CompanyName" autocomplete="off">
        </div>

      </div>
      <div class="col-lg-2">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-account-card-details"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" name="CustomerNumber" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CUSTOMERNUMBER' | translate }}" (keyup.enter)='listVw.updateFilter($event)' [(ngModel)]="kvp.CustomerNumber" autocomplete="off">
        </div>

      </div>

      @if (isCustomerReworkActive) {
        <div class="col-lg-3">
          <div class="input-group input-group-sm">
            <span class="input-group-text mdi mdi-domain"></span>
            <select class="form-select form-select-sm me-1 filter-input" name="CustomerType" data-testid="customer-search-customer-type" [(ngModel)]="kvp.CustomerType">
              <option value="">{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CUSTOMER-TYPE.BOTH' | translate }}</option>
              <option value="1">{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CUSTOMER-TYPE.COMPANY' | translate }}</option>
              <option value="2">{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CUSTOMER-TYPE.INDIVIDUALS' | translate }}</option>
            </select>
          </div>
        </div>

        <div class="col-lg-1">
        </div>
      } @else {
        <div class="col-lg-4">
        </div>
      }

    </div>

  </ng-container>

</t4-list-view>
